import { useEffect, useState } from 'react';

export const useDebounce = (value, delay = 300) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    //Clear timeout if the value changes before the delay
    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
};
